"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrashCanIcon20Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.TrashCanIcon20Light = forwardRef_1.forwardRef('TrashCanIcon20Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M8.5 8a.5.5 0 0 1 .5.5v6a.5.5 0 1 1-1 0v-6a.5.5 0 0 1 .5-.5Z" }),
        react_1.default.createElement("path", { d: "M12 8.5a.5.5 0 0 0-1 0v6a.5.5 0 1 0 1 0v-6Z" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 5V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h3.5a.5.5 0 0 1 0 1h-1.125l-.962 9.746A2.5 2.5 0 0 1 12.925 18h-5.85a2.5 2.5 0 0 1-2.488-2.254L3.625 6H2.5a.5.5 0 0 1 0-1H6Zm1-1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H7V4ZM4.63 6l.952 9.647A1.5 1.5 0 0 0 7.075 17h5.85a1.5 1.5 0 0 0 1.493-1.353L15.37 6H4.63Z" })));
});
